/**
 * FlightMiniSummary — compact selected-flight card reused in the passenger, review,
 * and payment steps so the traveller always sees what they're booking.
 *
 * @param {Object} props
 * @param {import('../../mock/types').Flight} props.flight
 * @param {import('../../mock/types').FlightSearchPayload} [props.criteria]
 */
import React from "react";
import "./flight-mini-summary.css";

const money = (n, c = "PKR") => `${c} ${Math.round(n).toLocaleString("en-PK")}`;

const stops = (f) =>
  f.stopCount === 0
    ? "Nonstop"
    : `${f.stopCount} stop${f.stopCount > 1 ? "s" : ""}${
        f.stopCities.length ? ` · ${f.stopCities.join(", ")}` : ""
      }`;

export default function FlightMiniSummary({ flight, criteria }) {
  if (!flight) return null;
  return (
    <div className="fms">
      <div className="fms__head">
        <img src={flight.airlineLogo} alt={flight.airline} className="fms__logo" width={36} height={36} />
        <div>
          <div className="fms__airline">{flight.airline}</div>
          <div className="fms__flight-no">{flight.flightNumber} · {flight.aircraft}</div>
        </div>
      </div>

      <div className="fms__route">
        <div className="fms__point">
          <span className="fms__time">{flight.departureTime}</span>
          <span className="fms__code">{flight.departureAirport.code}</span>
          <span className="fms__city">{flight.departureAirport.city}</span>
        </div>
        <div className="fms__mid">
          <span className="fms__dur">{flight.duration}</span>
          <span className="fms__line"><i className="fas fa-plane" aria-hidden="true" /></span>
          <span className="fms__stops">{stops(flight)}</span>
        </div>
        <div className="fms__point fms__point--right">
          <span className="fms__time">
            {flight.arrivalTime}
            {flight.arrivalDayOffset > 0 && <sup className="fms__offset"> +{flight.arrivalDayOffset}</sup>}
          </span>
          <span className="fms__code">{flight.arrivalAirport.code}</span>
          <span className="fms__city">{flight.arrivalAirport.city}</span>
        </div>
      </div>

      <div className="fms__tags">
        <span>{flight.cabinClass}</span>
        <span>{flight.baggageAllowance}</span>
        <span>{flight.refundable ? "Refundable" : "Non-refundable"}</span>
      </div>

      <div className="fms__price-row">
        <span className="fms__price-label">Fare per traveller</span>
        <span className="fms__price">{money(flight.finalPrice, flight.currency)}</span>
      </div>

      {criteria && (
        <div className="fms__criteria">
          {criteria.travellers} traveller{criteria.travellers === 1 ? "" : "s"} · {criteria.cabin}
        </div>
      )}
    </div>
  );
}
